import * as React from "react"
import { Label } from "@/components/ui/label"
import { Checkbox } from "@/components/ui/checkbox"
import { FormMessage } from "@/components/ui/form"
import { cn } from "@/lib/utils"

export interface LeadCheckboxFieldProps {
 label?: string
 checked: boolean
 onCheckedChange: (checked: boolean) => void
 error?: string
 hint?: string
 required?: boolean
 disabled?: boolean
 containerClassName?: string
 description?: string
}

export const LeadCheckboxField: React.FC<LeadCheckboxFieldProps> = ({
 label,
 checked,
 onCheckedChange,
 error,
 hint,
 required,
 disabled,
 containerClassName,
 description,
}) => {
 const fieldId = React.useId()

 return (
 <div className={cn("space-y-2", containerClassName)}>
 <div className="flex items-center space-x-2">
 <Checkbox
 id={fieldId}
 checked={checked}
 onCheckedChange={onCheckedChange}
 disabled={disabled}
 aria-invalid={!!error}
 aria-describedby={error ? `${fieldId}-error` : hint ? `${fieldId}-hint` : undefined}
 />
 {label && (
 <Label 
 htmlFor={fieldId}
 className={cn(
 "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
 required && "after:content-['*'] after:ml-0.5 after:text-destructive",
 error && "text-destructive"
 )}
 >
 {label}
 </Label>
 )}
 </div>
 {description && (
 <p className="text-[0.8rem] text-muted-foreground pl-6">
 {description}
 </p>
 )}
 {hint && !error && (
 <p id={`${fieldId}-hint`} className="text-[0.8rem] text-muted-foreground pl-6">
 {hint}
 </p>
 )}
 {error && (
 <FormMessage id={`${fieldId}-error`} className="text-[0.8rem] font-medium text-destructive pl-6">
 {error}
 </FormMessage>
 )}
 </div>
 )
}

